var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IONIcon/N/notifications/default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4715 11.9987C15.4131 11.9284 15.3558 11.8581 15.2996 11.7902C14.5261 10.8547 14.0582 10.2901 14.0582 7.64177C14.0582 6.27068 13.7302 5.14568 13.0837 4.30193C12.6069 3.67861 11.9625 3.20576 11.1132 2.85631C11.1022 2.85023 11.0925 2.84225 11.0843 2.83275C10.7788 1.80971 9.94281 1.12451 8.99992 1.12451C8.05703 1.12451 7.22136 1.80971 6.91586 2.8317C6.9077 2.84085 6.89808 2.84857 6.88738 2.85455C4.90527 3.67053 3.94199 5.23603 3.94199 7.64072C3.94199 10.2901 3.47476 10.8547 2.70062 11.7892C2.64437 11.857 2.58707 11.9259 2.52871 11.9976C2.37796 12.1794 2.28245 12.4006 2.25348 12.635C2.22451 12.8694 2.26329 13.1072 2.36523 13.3202C2.58215 13.7772 3.04445 14.061 3.57215 14.061H14.4316C14.9568 14.061 15.4159 13.7776 15.6335 13.3227C15.7359 13.1096 15.7751 12.8716 15.7464 12.637C15.7176 12.4023 15.6222 12.1808 15.4715 11.9987Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00018 16.875C9.5082 16.8746 10.0066 16.7367 10.4426 16.4759C10.8786 16.2152 11.2359 15.8413 11.4766 15.3939C11.4879 15.3724 11.4935 15.3484 11.4928 15.3242C11.4922 15.2999 11.4852 15.2763 11.4727 15.2555C11.4602 15.2347 11.4425 15.2176 11.4214 15.2056C11.4002 15.1937 11.3764 15.1875 11.3521 15.1875H6.64893C6.62465 15.1874 6.60075 15.1936 6.57958 15.2055C6.55841 15.2174 6.54067 15.2346 6.52811 15.2554C6.51554 15.2761 6.50857 15.2998 6.50787 15.3241C6.50717 15.3484 6.51277 15.3724 6.52413 15.3939C6.76478 15.8412 7.12201 16.2151 7.55793 16.4758C7.99386 16.7366 8.49222 16.8745 9.00018 16.875Z",
    fill: "#718096"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.1a49d5f01627de88cae9ee6ff8465384.svg";
export { ForwardRef as ReactComponent };